/**
 * O perfil acabou de ser salvo (PK-04): o `detail` é o perfil devolvido pelo `PATCH /me`.
 *
 * O shell carrega o próprio perfil uma vez só, para o rodapé da barra lateral; sem este
 * aviso, o nome e a foto trocados no Perfil só apareciam lá depois de recarregar a página.
 */
export const EVENTO_DE_PERFIL = 'dv:perfil-salvo'
